import React from "react"
import { BLOCK_DEFS } from "./blockSchema"

// Add-block menu. Calls onAdd(type) to append a new block.
export function BlockPalette({ onAdd }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {BLOCK_DEFS.map((def) => {
        const Icon = def.icon
        return (
          <button
            key={def.type}
            type="button"
            onClick={() => onAdd(def.type)}
            className="flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-[12px] font-medium text-slate-600 hover:border-slate-300 hover:bg-slate-50"
          >
            <Icon className="h-3.5 w-3.5" />
            {def.label}
          </button>
        )
      })}
    </div>
  )
}
